// Registry of the static pages: canonical path, aliases, title, description and the
// heading/intro copy that the prerendered content shell shows to crawlers.
// Plain CommonJS so scripts/prerender.js can require it on Node 12.
const site = require("./site");

const T = site.TITLE_SUFFIX;
const HERO = site.CLOUDINARY + "/c_fill,h_500,w_1800/f_auto,q_auto";

const PAGES = {
  home: {
    key: "home",
    path: "/",
    aliases: ["/index.html", "/tours"],
    title: "American Legacy Tours | Cincinnati Walking Tours",
    description:
      "Cincinnati's award-winning walking tours: historic, haunted, underground & food tours in Cincinnati, Newport & Covington. 3,500+ five-star reviews. Book today!",
    h1: "Historically Entertaining Walking Tours in Cincinnati",
    intro: site.SUMMARY,
    sitemap: true,
  },
  about: {
    key: "about",
    path: "/about-us",
    aliases: ["/about", "/about-us.html", "/about.html"],
    title: "About Us" + T,
    description:
      "Learn about American Legacy Tours, Cincinnati's TripAdvisor Travelers' Choice Award winner. Historically entertaining walking tours since 2009.",
    h1: "Our Story",
    intro:
      "Founded in 2009 with the Newport Gangster Tour, American Legacy Tours now leads a dozen historic, haunted, underground and food & drink tours across Cincinnati and Northern Kentucky.",
    heroImage: site.CLOUDINARY + "/f_auto,q_auto/img/cincinnati",
    sitemap: true,
  },
  contact: {
    key: "contact",
    path: "/contact-us",
    aliases: ["/contact-us.html"],
    title: "Contact Us" + T,
    description:
      "Contact American Legacy Tours in Cincinnati, OH. Call (859) 951-8560, email us, or send a message. We're happy to help you book or answer any questions.",
    h1: "Get in Touch",
    intro: "Questions about a tour, a group, or a gift certificate? Call, email, or send us a message.",
    heroImage: site.CLOUDINARY + "/f_auto,q_auto/img/shop",
    sitemap: true,
  },
  faq: {
    key: "faq",
    path: "/faq",
    aliases: ["/faq.html"],
    title: "Frequently Asked Questions" + T,
    description:
      "Answers about American Legacy Tours: arrival time, weather, kids and strollers, tour length, prices, meeting points, private tours and gift certificates.",
    h1: "Frequently Asked Questions",
    intro: "Everything you need to know before your tour.",
    heroImage: HERO + "/img/home/slider/slider-03",
    sitemap: true,
  },
  calendar: {
    key: "calendar",
    path: "/event-calendar",
    aliases: ["/event-calendar.html"],
    title: "Tour Calendar" + T,
    description:
      "Browse all upcoming American Legacy Tours dates and book your tickets online. Historic, haunted, underground & food tours in Cincinnati, Newport & Covington.",
    h1: "Tour Calendar",
    intro: "Browse all upcoming tour dates and book your spot.",
    heroImage: HERO + "/img/home/slider/slider-04",
    sitemap: true,
  },
  gc: {
    key: "gc",
    path: "/gift-certificates",
    aliases: ["/gift-certificates.html"],
    title: "Gift Certificates" + T,
    description:
      "Give the gift of adventure with American Legacy Tours gift certificates. Any dollar amount, never expires. Perfect for birthdays, holidays & any occasion.",
    h1: "Gift Certificates",
    intro: "Give the gift of historically entertaining tours. Any dollar amount, valid for any tour, and they never expire.",
    heroImage: HERO + "/img/home/slider/slider-02",
    sitemap: true,
  },
  privateTours: {
    key: "privateTours",
    path: "/private-tours",
    aliases: ["/private-tours.html"],
    title: "Private Tours" + T,
    description:
      "Book a private tour with American Legacy Tours: customizable historic, haunted and underground tours for corporate groups, families and events in Cincinnati.",
    h1: "Private Tours",
    intro:
      "Since 2009 we have hosted hundreds of private events a year: birthdays, bachelor and bachelorette parties, corporate team building and conventions. Food and transportation can be arranged.",
    heroImage: site.CLOUDINARY + "/f_auto,q_auto/img/citysky",
    sitemap: true,
  },
  featured: {
    key: "featured",
    path: "/featured",
    aliases: [],
    title: "Featured In" + T,
    description:
      "American Legacy Tours featured in National Geographic, New York Times, Lonely Planet, Forbes, BBC America & more. Cincinnati's most recognized tour company.",
    h1: "As Featured In",
    intro: "American Legacy Tours has been recognized by leading publications worldwide.",
    sitemap: true,
  },
  friends: {
    key: "friends",
    path: "/friends",
    aliases: [],
    title: "Our Friends" + T,
    description:
      "Friends of American Legacy Tours in Cincinnati and Northern Kentucky: Northern Row, City Center Properties, Model Group and Adam & Keli Photography.",
    h1: "Our Friends",
    intro: "The local businesses and partners who help make our tours possible.",
    sitemap: true,
  },
  hiring: {
    key: "hiring",
    path: "/hiring",
    aliases: [],
    title: "Now Hiring" + T,
    description:
      "Join the American Legacy Tours team in Cincinnati! We're hiring passionate tour guides. Apply now to share Cincinnati's incredible history with our guests.",
    h1: "Now Hiring Tour Guides",
    intro: "Love Cincinnati history and a crowd? We're looking for enthusiastic, entertaining guides.",
    sitemap: true,
  },
  reviews: {
    key: "reviews",
    path: "/reviews",
    aliases: [],
    title: "Reviews" + T,
    description:
      "Read what guests say about American Legacy Tours: thousands of five-star reviews on Google and TripAdvisor and a multi-year Travelers' Choice Award winner.",
    h1: "What Our Guests Say",
    intro: "Real reviews from real adventurers.",
    sitemap: true,
  },
  notFound: {
    key: "notFound",
    path: null,
    aliases: [],
    title: "Page Not Found" + T,
    description:
      "That page doesn't exist. Browse Cincinnati's award-winning walking tours or get in touch with American Legacy Tours.",
    h1: "We couldn't find that page",
    intro: "The tour or page you're looking for may have moved or is no longer offered.",
    noindex: true,
    sitemap: false,
  },
};

/** Props for <PageSEO> for a static page. */
function pageMeta(key) {
  const page = PAGES[key];
  if (!page) throw new Error("Unknown page key: " + key);
  return {
    title: page.title,
    description: page.description,
    path: page.path,
    image: page.image,
    noindex: !!page.noindex,
  };
}

/** Static pages that get a prerendered HTML file and a sitemap entry. */
function prerenderPages() {
  return Object.keys(PAGES)
    .map(function (key) {
      return PAGES[key];
    })
    .filter(function (page) {
      return page.path && page.sitemap;
    });
}

module.exports = { PAGES: PAGES, pageMeta: pageMeta, prerenderPages: prerenderPages };
